<template>
  <div>
    <ControlLabel v-bind="labelProps" :path="path" :responsive="responsive">
      {{ label }}
    </ControlLabel>
    <Select
      v-bind="$attrs"
      :multiple="multiple"
      :value="value"
      @input="handleChange(undefined, $event)"
    >
      <slot />
    </Select>
  </div>
</template>

<script>
import ControlLabel from './ControlLabel';
import control from './control';

export default {
  mixins: [control],

  props: {
    multiple: Boolean,
    labelProps: Object,
  },

  components: {ControlLabel},
};
</script>
